/**
 * Types for Affine iframe embed
 * Handles SSO authentication and PostMessage communication
 */

// PostMessage types — matches Affine embed-mode sender (modules/embed-mode/postmessage.ts)
export const AFFINE_MESSAGES = {
  READY: "AFFINE_READY",
  ERROR: "AFFINE_ERROR",
  ROUTE_CHANGE: "AFFINE_ROUTE_CHANGE",
} as const;

// Derive all Affine URLs from a single env source
export const AFFINE_URL =
  import.meta.env.VITE_AFFINE_URL || "https://affine.zaviago.com";
export const AFFINE_SSO_ENDPOINT = `${AFFINE_URL}/api/admin/sso`;
export const AFFINE_ORIGIN = new URL(AFFINE_URL).origin;

// 20s timeout per UX spec (not 30s like CRM)
export const LOAD_TIMEOUT_MS = 20_000;

export interface AffineEmbedProps {
  className?: string;
  onReady?: () => void;
  onError?: (error: string) => void;
}

export interface AffineEmbedRef {
  reload: () => void;
  readonly isReady: boolean;
}

/** Response from CP's get_affine_sso_url() */
export interface AffineSsoResponse {
  token: string;
  redirect_to: string;
  provisioned_now?: boolean;
}
